import { default as doCircleModalModel } from './circleModal';
import { default as doTopicModel } from './topicModel';

export const sagaCircleModal = doCircleModalModel.sagas;
export const sagaTopicModel = doTopicModel.sagas;
